<div class="row g-2 d-flex align-items-end">
  <div class="col">
    <div class="form-group w-100">
      <label class="form-label">Enter {{length}} digits OTP</label>
        <div class="">
          <div class="">
            <input type="number" [formControl]="otpForm" class="form-control rounded-0" (keydown.enter)="onSubmit()">
          </div>
        </div>
    </div>
  </div>
</div>